module.exports = __webpack_public_path__ + "img/winter-charging-fr.62e58e82.png";